import type { CSSProperties } from 'react';
import { useViewer } from '../store/context';
import type { RecentEntry } from '../filesource/types';
import { Logo } from './Logo';

function timeAgo(ms: number): string {
  const s = Math.max(1, Math.round((Date.now() - ms) / 1000));
  if (s < 60) return `${String(s)}s ago`;
  const m = Math.round(s / 60);
  if (m < 60) return `${String(m)}m ago`;
  const h = Math.round(m / 60);
  if (h < 24) return `${String(h)}h ago`;
  return `${String(Math.round(h / 24))}d ago`;
}

export function EmptyState({ onOpenFile }: { onOpenFile: () => void }) {
  const recents = useViewer((s) => s.recents);
  const openRecent = useViewer((s) => s.openRecent);

  return (
    <div className="flex h-full flex-col items-center justify-center gap-6 p-8 text-center">
      <div className="mr-empty-card flex max-w-md flex-col items-center rounded-xl border-2 border-dashed border-neutral-300 px-10 py-12 dark:border-neutral-700">
        <Logo size={64} />
        <h1 className="mt-4 text-2xl font-semibold tracking-tight text-neutral-800 dark:text-neutral-100">
          MarkRoom
        </h1>
        <p className="mt-1 text-neutral-600 dark:text-neutral-400">
          Drop a Markdown file here, or open one.
        </p>
        <button type="button" onClick={onOpenFile} className="mr-btn mr-btn--primary mt-5">
          Open file…
        </button>
      </div>

      {recents.length > 0 && (
        <div className="w-full max-w-md text-left">
          <h2 className="mb-2 text-xs font-semibold tracking-wide text-neutral-600 uppercase dark:text-neutral-400">
            Recent
          </h2>
          <ul className="divide-y divide-neutral-200 overflow-hidden rounded-lg border border-neutral-200 dark:divide-neutral-800 dark:border-neutral-800">
            {recents.map((entry: RecentEntry, i: number) => (
              <li key={entry.id} className="mr-recent-item" style={{ '--i': i } as CSSProperties}>
                <button
                  type="button"
                  onClick={() => void openRecent(entry)}
                  className="flex w-full items-center justify-between gap-3 px-3 py-2 text-left hover:bg-neutral-100 dark:hover:bg-neutral-800"
                >
                  <span className="truncate text-sm text-neutral-700 dark:text-neutral-200">
                    {entry.name}
                  </span>
                  <span className="shrink-0 text-xs text-neutral-500 dark:text-neutral-400">
                    {timeAgo(entry.openedAt)}
                  </span>
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
